import { render, staticRenderFns } from "./Periods.vue?vue&type=template&id=6f85b5a4&scoped=true"
import script from "./Periods.ts?vue&type=script&lang=ts&external"
export * from "./Periods.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f85b5a4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src2316091614/src/sctd-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6f85b5a4')) {
      api.createRecord('6f85b5a4', component.options)
    } else {
      api.reload('6f85b5a4', component.options)
    }
    module.hot.accept("./Periods.vue?vue&type=template&id=6f85b5a4&scoped=true", function () {
      api.rerender('6f85b5a4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/Modules/Cups/components/tabs/Periods/Periods.vue"
export default component.exports